// CSV export utility for BICENTER AI admin dashboard

const escapeCSV = (val) => {
  if (val === null || val === undefined) return "";
  const s = typeof val === "string" ? val : String(val);
  // If contains comma, quote, newline or starts with =/+/-/@ (CSV injection), wrap in quotes
  if (/[",\n\r]/.test(s) || /^[=+\-@]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

const formatDate = (v) => {
  if (!v) return "";
  try {
    return new Date(v).toISOString();
  } catch {
    return v;
  }
};

/**
 * Export an array of records to CSV.
 * @param {Array<Object>} rows
 * @param {Array<{k: string, h: string, fmt?: Function}>} columns
 * @param {string} filename
 */
export const exportToCSV = (rows, columns, filename) => {
  if (!rows || rows.length === 0) return false;

  const header = columns.map((c) => escapeCSV(c.h)).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((c) => {
          let v = row[c.k];
          if (c.k === "created_at" || c.k === "preferred_date") v = formatDate(v);
          return escapeCSV(v);
        })
        .join(",")
    )
    .join("\n");

  // BOM for Excel UTF-8 compatibility
  const csv = "\ufeff" + header + "\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}_${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return true;
};
